import { useLanguage } from "../context/languageProvider";
import { Language, noBreakSpace } from "../utils/constants";
import { isNumberValue } from "../utils/helpers";
import { toFormattedNumberStr } from "../utils/numberHelpers";

export type CurrencyHook = {
  toCurrency: (value: number | null | undefined, toDecimal?: boolean) => string;
  naValueCurrencySign: string;
}

const useCurrency = (): CurrencyHook => {

  const currencySign = "$";
  const currencyDecimalPlaces = 2;

  const language = useLanguage();

  const getNaValue = (): string => language.getLanguage() === Language.fr ? "XX" : "--";
  const getNaValueCurrencySign = (): string => formatCurrencyStr(getNaValue());

  const toCurrency = (value: number | null | undefined, toDecimal?: boolean): string => {

    if (!isNumberValue(value)) {
      return getNaValue();
    }

    const fStr = toFormattedNumberStr(value, language.getLanguage(), toDecimal ? currencyDecimalPlaces : 0, toDecimal);

    const result = formatCurrencyStr(fStr);

    return result;
  };

  const formatCurrencyStr = (value: unknown): string =>
    (
      language.getLanguage() === Language.fr
        ? `${value}${noBreakSpace}${currencySign}` // Fr: there MUST be space between value and currency sign
        : `${currencySign}${value}` // En: there must be NO space between currency sign and value
    );

  return {
    toCurrency: toCurrency,
    get naValueCurrencySign() {
      return getNaValueCurrencySign();
    }
  };
};

export default useCurrency;
